import React from "react";
import { useNavigate } from "react-router-dom";
import "./CoverPage.css";
import Logo from "../assets/logo.png";
import { ArrowRight, Stars } from "lucide-react";

const CoverPage = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/symptom-checker"); // or wherever you want to route
  };

  return (
    <div className="cover-page">
      <div className="logo-section">
        <div className="logo-icon"><Stars color="white" size={60}/></div>
        <h1 className="logo-text">CLINICAL INTELLIGENCE</h1>
        <br></br>
        <p style={{margin : "20px"}} className="text-center text-light">Welcome to QUREO your personal companion for health and wellness.

           
            </p>
      </div>

      <hr></hr>
      
      <button onClick={()=> navigate("/symptom-checker") } style={{width : "90%", height : "10%"}} className="btn btn-accent btn-block continue-btn" onClick={handleContinue}>
        Continue
        <ArrowRight size={14}/>
      </button>
    </div>
  );
};

export default CoverPage;